import { render, staticRenderFns } from "./trashItems.vue?vue&type=template&id=3c572327&scoped=true"
import script from "./trashItems.vue?vue&type=script&lang=js"
export * from "./trashItems.vue?vue&type=script&lang=js"
import style0 from "./trashItems.vue?vue&type=style&index=0&id=3c572327&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c572327",
  null
  
)

export default component.exports